import { c as _c } from "react/compiler-runtime";
import type { FanUpMessage } from '@module/types/centrifuge/public-message/upMessageTypes';
interface Props {
  item: FanUpMessage;
}
export default function FanUpChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  const t0 = `${message.nick}님이 ${message.rank}위로 팬 랭킹이 올라갔습니다! 축하축하~`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="mb-[3px] whitespace-pre-wrap text-cht_al_3"><div>{t0}</div></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}